import { css, CSSResult } from 'lit'

export const partsStyle: CSSResult = css`
  :host {
    display: contents;
  }
`
